import { useTranslation, Trans } from "react-i18next";

/**
 * Help page component explaining how to edit tasks and navigate between files and sheets.
 *
 * @component
 */
function HelpPageEditTasks() {
  const { t } = useTranslation("modals");

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h2 className="text-xl font-semibold">{t("sheetagent.help.edittasks.title")}</h2>
        <p className="text-sm text-muted-foreground">
          {t("sheetagent.help.edittasks.description")}
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.edittasks.understandingtitle")}</h3>
          <div className="space-y-2 text-sm text-muted-foreground">
            <p className="leading-relaxed">
              {t("sheetagent.help.edittasks.understandingdescription")}
            </p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>
                <strong className="text-foreground">{t("sheetagent.help.edittasks.understandinglist1label")}</strong>{" "}
                {t("sheetagent.help.edittasks.understandinglist1value")}
              </li>
              <li>
                <strong className="text-foreground">{t("sheetagent.help.edittasks.understandinglist2label")}</strong>{" "}
                {t("sheetagent.help.edittasks.understandinglist2value")}
              </li>
            </ul>
          </div>
        </div>

        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.edittasks.switchingtitle")}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            <Trans
              i18nKey="sheetagent.help.edittasks.switchingdescription"
              ns="modals"
              components={{
                strong: <strong className="text-foreground" />,
              }}
            />
          </p>
        </div>

        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.edittasks.organizationtitle")}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {t("sheetagent.help.edittasks.organizationdescription")}
          </p>
          <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1 ml-2">
            <li>
              <Trans
                i18nKey="sheetagent.help.edittasks.organizationlist1"
                ns="modals"
                components={{
                  strong: <strong className="text-foreground" />,
                }}
              />
            </li>
            <li>
              <Trans
                i18nKey="sheetagent.help.edittasks.organizationlist2"
                ns="modals"
                components={{
                  strong: <strong className="text-foreground" />,
                }}
              />
            </li>
            <li>{t("sheetagent.help.edittasks.organizationlist3")}</li>
          </ul>
        </div>

        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.edittasks.answeringtitle")}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed mb-2">
            {t("sheetagent.help.edittasks.answeringdescription")}
          </p>
          <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1 ml-2">
            <li>
              <strong className="text-foreground">{t("sheetagent.help.edittasks.answeringlist1label")}</strong>{" "}
              {t("sheetagent.help.edittasks.answeringlist1value")}
            </li>
            <li>
              <strong className="text-foreground">{t("sheetagent.help.edittasks.answeringlist2label")}</strong>{" "}
              {t("sheetagent.help.edittasks.answeringlist2value")}
            </li>
            <li>
              <strong className="text-foreground">{t("sheetagent.help.edittasks.answeringlist3label")}</strong>{" "}
              {t("sheetagent.help.edittasks.answeringlist3value")}
            </li>
            {/* TODO: This is info for delete button, currently not implemented yet */}
            {/* <li>
              <strong className="text-foreground">{t("sheetagent.help.edittasks.answeringlist4label")}</strong>{" "}
              {t("sheetagent.help.edittasks.answeringlist4value")}
            </li> */}
          </ul>
          <div className="mt-3 p-3 bg-green-50 dark:bg-green-950/20 border border-green-200 dark:border-green-800 rounded-md">
            <p className="text-sm text-green-900 dark:text-green-100">
              <strong className="font-medium">{t("sheetagent.help.edittasks.goodnewstitle")}</strong>{" "}
              {t("sheetagent.help.edittasks.goodnewscontent")}
            </p>
          </div>
        </div>

        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.edittasks.copyingtitle")}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            <Trans
              i18nKey="sheetagent.help.edittasks.copyingdescription"
              ns="modals"
              components={{
                strong: <strong className="text-foreground" />,
              }}
            />
          </p>
        </div>
      </div>

      <div className="p-4 bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-md">
        <p className="text-sm text-blue-900 dark:text-blue-100">
          <strong className="font-medium">{t("sheetagent.help.edittasks.remembertitle")}</strong>{" "}
          {t("sheetagent.help.edittasks.remembercontent")}
        </p>
      </div>
    </div>
  );
}

export default HelpPageEditTasks;
